import { render, staticRenderFns } from "./algorithmButton.vue?vue&type=template&id=701f8057&"
import script from "./algorithmButton.vue?vue&type=script&lang=js&"
export * from "./algorithmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports